import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PinGroup } from 'src/app/models/PinGroup';
import { OrderService } from 'src/app/services/order.service';
import { PinService } from 'src/app/services/pin.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery;

@Component({
  selector: 'app-my-pines',
  templateUrl: './my-pines.component.html',
  styleUrls: ['./my-pines.component.scss']
})
export class MyPinesComponent implements OnInit {
  pinesGroup: PinGroup[] = [];
  public activeSlideIndex: any = 0;
  imagesUrl = CONSTANTES.pasadoresUrl;

  constructor(
    private orderService: OrderService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private pinService: PinService
  ) { }

  ngOnInit() {
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      this.router.navigate(['login']);
    }
    this.getPinGroup();
  }

  getPinGroup() {
    let nid = localStorage.getItem("nid");

    //Se solicitan todos los pedidos del usuario que se encuentren finalizados
    this.pinService.getPinsByUser(nid).subscribe(
      data => {
        if (getToken(data)) {
          if (data.pinGroups != null) {
            this.pinesGroup = data.pinGroups;
            this.spinner.hide();
          } else {
            this.toastr.info("NO EXISTEN PINES", "INFO");
            this.spinner.hide();
            this.router.navigate(['home']);
          }

        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS PINES", "ERROR");
      }
    )
  }

  deleteGroup() {
    let pinGroup = new PinGroup()
    if (typeof this.activeSlideIndex === 'number') {
      pinGroup = this.pinesGroup[0];
    }
    else {
      pinGroup = this.pinesGroup[this.activeSlideIndex.relatedTarget];
    }

    this.spinner.show();
    this.pinService.deletePinGroup(pinGroup).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success("CONJUNTO DE PASADORES ELIMINADO")
          this.pinesGroup = this.pinesGroup.filter(group => group !== pinGroup)
          this.spinner.hide()
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.spinner.hide()
          this.router.navigate(['login']);
        }
      }, error => {
        this.toastr.error("ERROR AL BORRAR EL CONJUNTO DE PASADORES, YA QUE TIENE PEDIDOS ASOCIADOS")
        this.spinner.hide()
      }
    )
  }
}
